module.exports = __webpack_public_path__ + "img/action-white.a022ea55.svg";